const get = require('lodash/get');

const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/assets-common/api-factory');
const serviceFactory = require('../resources/assets-common/service-factory');
const routeAdderFactory = require('../resources/assets-common/route-adder-factory');
const parsePosition = require('../resources/assets-common/parse-position');
const merge = require('lodash/fp/merge');

function parseCashPosition(position) {
  const p = path => get(position, path, null);

  return merge(
    parsePosition(position),
    {
      account: p('ratesHistory.psActNmb'),
      balance: p('psMktValuePosCcy'),
      accruedInterest: p('psAccIntRefCcy'),

      dayChange: p(['ratesHistory', 'dayChg']),
      dayChangePercentage: p(['ratesHistory', 'dayChgPct']),
      availableBalance: p('psAvaBal'),
    }
  );
}

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/cash/${apiConfig.apiversion}/`,
    authToken: config.authToken,
    assetCategory: '1',
    positionsUrl: 'cash-positions',
    transactionsUrl: 'cash-transactions',
    valueMovementUrl: 'cash-value-movement',
  });

  const service = serviceFactory({
    api,
    parsePosition: parseCashPosition,
  });

  return routeAdderFactory({ assetType: 'cash', service });
}

module.exports = addRoutes;

